// extracted by mini-css-extract-plugin
module.exports = {"innerTable":"styles_innerTable__b6Idc","header":"styles_header__1xZfa","tableTitle":"styles_tableTitle__1ng3a","licensePlate":"styles_licensePlate__3ewWK"};